import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule, ItNotificationService } from 'design-angular-kit';
import { environment } from '../../../../../environments/environment';
import { NoteService } from '../../../../services/note.service';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-new-note-modal',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './new-note-modal.component.html',
  styleUrl: './new-note-modal.component.scss'
})
export class NewNoteModalComponent {
  @Input() transitionId!: string;

  @Output() newNote = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  noteTypes: any[] = [];

  selectedTypeNoteId: number | null = null;
  text: string | null = null;

  constructor(private http: HttpClient, private noteService: NoteService, private authService: AuthService, private notification: ItNotificationService) { }

  ngOnInit(): void {
    this.loadNoteTypes();
  }

  loadNoteTypes(): void {
    this.http.get<any[]>(`${environment.beServiceUrl}/v1/note/find-types?isInsertableByUser=true`).subscribe((data) => {
      this.noteTypes = data;
    });
  }

  reset() {
    this.selectedTypeNoteId = null;
    this.text = null;
  }

  confirm(): void {
    const request = {
      transitionId: this.transitionId,
      typeId: this.selectedTypeNoteId,
      text: this.text,
      insertUserCode: this.authService.userInfo.username
    }
    this.noteService.insertNote(request).subscribe((response) => {
      this.newNote.emit();
      this.reset();
    }, (err) => {
      this.notification.error(
          'Si è verificato un problema durante il salvataggio della nota.'
        );
    });
  }

  cancel(): void {
    this.reset();
    this.cancelled.emit();
  }
}
